// extracted by css-extract-rspack-plugin
export default {"container":"_a64af95f"};